import React from "react";

import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";

import { Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import {
  useEdgePinchProjectslist,

  useWorkOrderList,
} from "../../../projectManagementQueries";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import { useFetchContext } from "../../../../common/FetchContext";
import { toast } from "react-toastify";

export const EdgePinchDownloadPage = () => {
  const formikRef = React.useRef<any>();
  const [clearedValues, setClearedValues] = React.useState(false);
  const [selectedProject, setSelectedProject] = React.useState<any>(null);
  const [selectedWorkorder, setSelectedWorkorder] = React.useState<any>(null);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [isDownloading, setIsDownloading] = React.useState(false);
  const history = useHistory();
  const { authAxios } = useFetchContext();
  const {
    error: errorProjects,
    data: Edgepinchprojects,
    isLoading: isLoadingProjects,
    isError: isErrorProjects,
  } = useEdgePinchProjectslist();

  const { data: WorkOrderList, isLoading: isWorkOrderList } = useWorkOrderList(
    selectedProject?.id,
  );

  const handleDownload = async (): Promise<any> => {
    try {
      if (!selectedProject || !selectedWorkorder) return;

      setIsDownloading(true);

      const project_number = selectedProject?.number;
      const bom_name = selectedWorkorder?.name;

      const response = await authAxios.get(
        `/edge_pinch_download/download/?project_number=${project_number}&bom_name=${bom_name}`,
        {
          responseType: "blob",
        },
      );

      const downloadUrl = URL.createObjectURL(response.data);

      const a = document.createElement("a");
      a.href = downloadUrl;

      a.download = `${project_number}_${bom_name}_${moment().format(
        "MMM-DD-YYYY-HHMMSS",
      )}`;

      document.body.appendChild(a);
      a.click();

      a.remove();

      URL.revokeObjectURL(downloadUrl);
      formikRef.current?.resetForm({
        values: {
          Project_id: null,
        },
      });

      setSelectedProject(null);
      setSelectedWorkorder(null);
      setOpenDialog(false);
      setClearedValues(true);
    } catch (error: any) {
      let errorMsg = "Something went wrong";

      try {
        if (error?.response?.data instanceof Blob) {
          const text = await error.response.data.text();
          const json = JSON.parse(text);

          errorMsg = json?.message || errorMsg;
        } else {
          errorMsg =
            error?.response?.data?.message || error?.message || errorMsg;
        }
      } catch {
        errorMsg = "Something went wrong";
      }

      toast.error(`Download failed: ${errorMsg}`);
    } finally {
      setIsDownloading(false);
    }
  };
  if (isLoadingProjects) {
    return (
      <Backdrop open={isLoadingProjects}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return (
    <>
      <Grid container direction="column" spacing={2}>
        <Grid item xs={12}>
          <Formik
            innerRef={formikRef}
            initialValues={{
              Project_id: null,
            }}
            validationSchema={Yup.object({
              Project_id: Yup.object()
                .nullable()
                .required("project is required"),
            })}
            onSubmit={async () => {}}
          >
            {({ values }) => {
              return (
                <Form>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item xs={6}>
                      <Autocomplete
                        value={selectedProject}
                        options={Edgepinchprojects || []}
                        getOptionLabel={(project: any) => project?.number || ""}
                        onChange={(_: any, value: any) => {
                          setSelectedProject(value || null);
                          setSelectedWorkorder(null);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select a Project"
                            variant="standard"
                            fullWidth
                          />
                        )}
                      />
                    </Grid>

                    <Grid item>
                      <Button
                        data-testid="clearSerialNumber"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          formikRef.current?.resetForm({
                            values: {
                              Project_id: null,
                            },
                          });

                          setSelectedProject(null);
                          setSelectedWorkorder(null);
                          setOpenDialog(false);
                          setClearedValues(true);
                        }}
                      >
                        Clear
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: 16 }}>
        {selectedProject && (
          <>
            <Grid item xs={12}>
              <Typography variant="h6">
                {`WorkOrders Under the Project ${selectedProject?.number}`}
              </Typography>
            </Grid>

            {isWorkOrderList ? (
              <Backdrop open={isWorkOrderList}>
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : (
              (WorkOrderList || []).map((workorder: any) => (
                <Grid item xs={12} sm={6} md={3} key={workorder.id}>
                  <Paper
                    elevation={selectedWorkorder?.id === workorder.id ? 8 : 3}
                    onClick={() => setSelectedWorkorder(workorder)}
                    style={{
                      padding: 10,
                      borderRadius: 6,
                      minHeight: 55,
                      width: 220,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      cursor: "pointer",
                      backgroundColor:
                        selectedWorkorder?.id === workorder.id
                          ? "#FFA500"
                          : "#ffffff",
                      transition: "0.2s ease",
                      border:
                        selectedWorkorder?.id === workorder.id
                          ? "2px solid #FFA500"
                          : "1px solid #e0e0e0",
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      style={{ fontSize: 12, fontWeight: 600 }}
                    >
                      {workorder.name}
                    </Typography>
                  </Paper>
                </Grid>
              ))
            )}
          </>
        )}

        {selectedWorkorder && (
          <Grid
            item
            xs={12}
            style={{
              marginTop: 20,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => setOpenDialog(true)}
            >
              Download
            </Button>
          </Grid>
        )}
      </Grid>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirm Download</DialogTitle>

        <DialogContent>
          <DialogContentText>
            {`Do you want to download the EdgePinch file for Project "${selectedProject?.number}" and Workorder "${selectedWorkorder?.name}" ?`}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="secondary">
            Cancel
          </Button>

          <Button
            onClick={async () => {
              await handleDownload();
              setOpenDialog(false);
            }}
            color="primary"
            variant="contained"
            disabled={isDownloading}
            startIcon={
              isDownloading ? (
                <CircularProgress size={18} color="inherit" />
              ) : null
            }
          >
            {isDownloading ? "Downloading..." : "Confirm Download"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
